"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpService = void 0;
const axios_1 = __importDefault(require("axios"));
const HttpServiceHelper_1 = require("./HttpServiceHelper");
class HttpService {
    static init(options) {
        HttpService.storage = options.storage;
        HttpService.apiRoot = options.apiRoot;
        HttpService.isMock = options.isMock ? options.isMock : false;
        HttpService.http = axios_1.default.create({
            timeout: 10000
        });
        // Add response formatters
        HttpService.http.interceptors.response.use((response) => response, (error) => HttpServiceHelper_1.HttpServiceHelper.errorFormatter(error));
    }
    static getCacheEntry(path, maxCacheMinutes) {
        const cacheEntry = HttpService.cache[path];
        const nowSeconds = Math.round(Date.now() / 1000);
        if (cacheEntry && (nowSeconds - cacheEntry.timeStampSeconds) < maxCacheMinutes * 60) {
            return HttpService.cache[path].payload;
        }
        else {
            return null;
        }
    }
    static setCacheEntry(path, value) {
        HttpService.cache[path] = {
            timeStampSeconds: Math.round(Date.now() / 1000),
            payload: value
        };
    }
    resetCache() {
        HttpService.cache = {};
    }
    async get(path, options) {
        const axiosConfig = await HttpService.getConfig(options);
        if (options && options.maxCacheMinutes) {
            const cacheEntry = HttpService.getCacheEntry(path, options.maxCacheMinutes);
            if (cacheEntry) {
                if (cacheEntry && Array.isArray(cacheEntry)) {
                    // if the cache entry is an empty array, don't serve it from the cache
                    if (cacheEntry.length > 0) {
                        return Promise.resolve(cacheEntry);
                    }
                }
                else {
                    return Promise.resolve(cacheEntry);
                }
            }
        }
        return HttpService.http.get(`${HttpService.apiRoot}${path}`, axiosConfig).then(response => {
            HttpService.setCacheEntry(path, response.data);
            return response.data;
        });
    }
    async post(path, data, options) {
        const axiosConfig = await HttpService.getConfig(options);
        return HttpService.http.post(`${HttpService.apiRoot}${path}`, data, axiosConfig).then(response => {
            return response.data;
        });
    }
    async put(path, data, options) {
        const axiosConfig = await HttpService.getConfig(options);
        return HttpService.http.put(`${HttpService.apiRoot}${path}`, data, axiosConfig).then(response => {
            return response.data;
        });
    }
    async delete(path, options) {
        const axiosConfig = await HttpService.getConfig(options);
        return HttpService.http.delete(`${HttpService.apiRoot}${path}`, axiosConfig).then(response => {
            return response.data;
        });
    }
}
exports.HttpService = HttpService;
_a = HttpService;
HttpService.cache = {};
HttpService.getConfig = async (options) => {
    const token = await HttpService.storage.getItem('token');
    const axiosConfig = {};
    if (token) {
        axiosConfig.headers = {
            "Authorization": `Bearer ${token}`
        };
    }
    if (options && options.timeout) {
        axiosConfig.timeout = options.timeout;
    }
    return axiosConfig;
};
